import { Monogram } from './Monogram';
import { cn } from '@/lib/utils';

/**
 * The vendor's mark for a row or a header: the stored logo when the server has
 * one (OrderSummary.logoUrl), otherwise the initials monogram. Logos are wide
 * wordmarks on white, so the slot is a wide box that letterboxes the image;
 * the monogram keeps its square. `size` picks the row or the header slot.
 */
export function VendorMark({ name, logoUrl, size = 'row', className }: { name: string; logoUrl?: string | null; size?: 'row' | 'header'; className?: string }) {
  if (!logoUrl) return <Monogram name={name} className={className} />;
  return <span className={cn('box-border inline-flex h-8 w-[72px] shrink-0 items-center justify-center rounded-lg border border-border bg-white px-[5px] py-[3px]', size === 'header' && 'h-14 w-[150px] rounded-[10px] px-2.5 py-1.5', className)}><img className="block h-auto max-h-full w-auto max-w-full object-contain" src={logoUrl} alt="" loading="lazy" decoding="async" /></span>;
}
